module.exports = __webpack_public_path__ + "static/media/monoprix.a59d3267.png";